module.exports = __webpack_public_path__ + "img/IPalintonon64_ua.5141b9d2.webp";